import {Modal, styled} from '@innowise-group/ui-kit';

export const Container = styled(Modal.Container)<{zoom: number}>`
  width: 63.25rem;
  height: 49.375rem;
  max-width: 92vw;
  max-height: 95vh;
  border-radius: 0.625rem;
  background: ${({theme}) => theme.palette.specials.meetings.background};
  box-shadow: 0px 0.25rem 0.625rem 0px rgba(0, 0, 0, 0.15);
  padding: 1.38% 3.95% 3.95%;
  zoom: ${({zoom}) => 1 / Number(zoom)};

  @media (max-width: 630px) {
    min-width: 92vw;
    max-width: 92vw;
    padding: 0.625rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

export const ModalHeader = styled(Modal.Header)`
  padding: 1.073% 0;
  & > p {
    color: ${({theme}) => theme.palette.specials.meetings.title};
    font-family: Manrope;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.78;

    @media (max-width: 769px) {
      font-size: 1rem;
    }

    @media (max-width: 480px) {
      font-size: 0.875rem;
    }
  }
`;

export const ModalBody = styled(Modal.Body)`
  height: 100%;
  padding: 1rem 0 0;

  &::-webkit-scrollbar {
    height: 0.625rem;
    width: 0.625rem;
  }

  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-corner {
    background: ${({theme}) => theme.palette.generalAlt.scrollbar.track};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.625rem;
    background: ${({theme}) => theme.palette.generalAlt.scrollbar.thumb};
    border: 0.125rem solid ${({theme}) => theme.palette.generalAlt.scrollbar.track};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({theme}) => theme.palette.general.lightGrey[80]};
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0 0;
  }
`;
